import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import {
	NotificationCardWrapper,
	NotificationCardContainer,
	NotificationCardHeader,
	NotificationCardContent,
	NotFoundContainer,
} from "./NotificationCard.style";
import { AbandonedBasketLink, LoaderWrapper } from "./NotificationPopUp.style";
import Loader from "../Loader/Loader";
import t from "../../i18n/translate";
import { useDispatch } from "react-redux";
import { initBasket } from "../../store/actions/cartAction";
import BuyNormalImg from "../../assets/icons/buy.jpg";
import BuyExpressImg from "../../assets/icons/buy_express.jpg";
import ExpressImg from "../../assets/icons/delixpress_logo2.svg";
import NormalImg from "../../assets/icons/delishop_logo2.svg";
import WalletImg from "../../assets/icons/wallet.svg";
import AbandonedBasketIcon from "../../assets/images/abandoned-basket.jpg";

const NotificationCard = ({ notification, loading }) => {
	const dispatch = useDispatch();
	const mountedRef = useRef(true);
	const notification_length = Object.keys(notification).length;

	const lang = localStorage.getItem("lang");
	const orderId = localStorage.getItem("order_id");
	const cartType = localStorage.getItem("expressMode") ? "express" : "normal";

	const getSentPeriod = (sent_time) => {
		let now = new Date();
		let sent_date = new Date(sent_time);
		let time = now - sent_date;
		let getSentPeriod = 0;
		let typeOfTime = "";
		let result = "";

		if (time / (1000 * 60 * 60 * 24 * 7 * 30 * 12) >= 1) {
			getSentPeriod = Math.floor(time / (1000 * 60 * 60 * 24 * 7 * 30 * 12));
			typeOfTime = "year";
		} else if (time / (1000 * 60 * 60 * 24 * 7 * 30) >= 1) {
			getSentPeriod = Math.floor(time / (1000 * 60 * 60 * 24 * 7 * 30));
			typeOfTime = "month";
		} else if (time / (1000 * 60 * 60 * 24 * 7) >= 1) {
			getSentPeriod = Math.floor(time / (1000 * 60 * 60 * 24 * 7));
			typeOfTime = "week";
		} else if (time / (1000 * 60 * 60 * 24) >= 1) {
			getSentPeriod = Math.floor(time / (1000 * 60 * 60 * 24));
			typeOfTime = "day";
		} else if (time / (1000 * 60 * 60) >= 1) {
			getSentPeriod = Math.floor(time / (1000 * 60 * 60));
			typeOfTime = "hour";
		} else if (time / (1000 * 60) >= 1) {
			getSentPeriod = Math.floor(time / (1000 * 60));
			typeOfTime = "minute";
		}

		if (getSentPeriod > 1) result = getSentPeriod + " " + typeOfTime + "s ago";
		else if (getSentPeriod === 1)
			result = getSentPeriod + " " + typeOfTime + " ago";
		else result = "just now";

		return result;
	};

	const handleNavigateCheckout = () => {
		window.location.href = "/checkout"
	}

	useEffect(() => {
		if (mountedRef.current) {
			if (localStorage.getItem("expressMode")) {
				initBasket("express", dispatch);
			}
		}
		return () => {
			mountedRef.current = false;
		};
	}, [dispatch, notification]);

	return (
		<NotificationCardWrapper>
			<NotificationCardContainer>
				{loading ? (
					<LoaderWrapper>
						<Loader
							color={cartType === "express" ? "#f01266" : "#9cc54b"}
							h="40"
							style={{
								borderBottom: `3px solid ${
									cartType === "express" ? "#f01266" : "#9cc54b"
								}`,
							}}
						/>
					</LoaderWrapper>
				) : notification_length ? (
					<>
						<NotificationCardHeader>
							<div className="icon">
								<img
									src={
										["campaign", "general","landingPage","partnerPage"].includes(notification.type)
											? notification.data.icon
												? notification.data.icon
												: notification?.data?.generalData?.type === 8 // express
												? ExpressImg
												: cartType === "express"
												? ExpressImg
												: NormalImg
											: notification.type === "walletUpdate"
											? WalletImg
											: notification?.type === "expressBasket"
											? BuyExpressImg
											: notification?.type === "normalBasket"
											? BuyNormalImg
											: notification.type === "abandonedBasket"
											? AbandonedBasketIcon
											: cartType === "express"
											? ExpressImg
											: NormalImg
									}
									alt="Icon"
								/>
							</div>
							<div className="header-content">
								<div className="title">
									{["campaign", "general", "normalBasket", "expressBasket", "abandonedBasket","landingPage","partnerPage"].includes(
										notification.type
									) ? (
										<div dangerouslySetInnerHTML={{ __html: notification.data.title }} />
									) : notification.type === "walletUpdate" ? (
										notification.data.content.title
									) : (
										<p>Order No: #{notification.data.order.number}</p>
									)}
								</div>
								<p className="sent-time">{getSentPeriod(notification.date)}</p>
							</div>
						</NotificationCardHeader>
						<NotificationCardContent>
							{["campaign", "general", "normalBasket", "expressBasket", "abandonedBasket","landingPage","partnerPage"].includes(
								notification.type
							) ? (
								<div dangerouslySetInnerHTML={{ __html: notification.data.body }} />
							) : notification.type === "walletUpdate" ? (
								lang === "km" ? (
									notification.data.content.description.km
								) : (
									notification.data.content.description.en
								)
							) : (
								<p className="text-muted">{notification.data.order.description}</p>
							)}

							{/* click action (link) */}
							{notification?.data?.action ? (
								<a
									href={notification?.data?.action}
									rel="external"
									style={{
										display: "inline-block",
										marginTop: "1rem",
										color:
											notification?.data?.generalData?.type === 8 // express
												? "#f01266"
												: cartType === "express"
												? "#f01266"
												: "#9cc54b",
									}}
								>
									{t("notification_view_link_title")}
								</a>
							) : notification?.type === "expressBasket" && parseInt(orderId) !== 0 ? (
								<div
									onClick={() => {
										initBasket("express", dispatch);
										localStorage.setItem("expressMode", true);
									}}
								>
									<Link
										to="/checkout"
										style={{
											display: "inline-block",
											marginTop: "1rem",
											color: "#f01266",
										}}
									>
										{t("shop_check_out_now_button")}
									</Link>
								</div>
							) : notification?.type === "normalBasket" && parseInt(orderId) !== 0 ? (
								<div
									onClick={() => {
										initBasket("normal", dispatch);
										localStorage.removeItem("expressMode");
									}}
								>
									<Link
										to="/checkout"
										style={{
											display: "inline-block",
											marginTop: "1rem",
											color: "#9cc54b",
										}}
									>
										{t("shop_check_out_now_button")}
									</Link>
								</div>
							) : notification?.type === "abandonedBasket" ? (
								<div
									onClick={() => {
										initBasket("normal", dispatch);
										localStorage.removeItem("expressMode");
									}}
								>
									<AbandonedBasketLink
										onClick={handleNavigateCheckout}
										style={{
											display: "inline-block",
											marginTop: "1rem",
											color: "#9cc54b",
											cursor: 'pointer'
										}}
									>
										{t("shop_check_out_now_button")}
									</AbandonedBasketLink>
								</div>
							) : null}
						</NotificationCardContent>
					</>
				) : (
					<NotFoundContainer>
						<p>Notification Not found</p>
					</NotFoundContainer>
				)}
			</NotificationCardContainer>
		</NotificationCardWrapper>
	);
};

export default NotificationCard;
